<template>
  <!-- begin:: Header -->
  <div
    id="kt_header"
    ref="kt_header"
    class="header"
    v-bind:class="headerClasses"
  >
    <div
      class="container-fluid d-flex align-items-center justify-content-between"
    >
      <!-- begin:: Header Menu -->
      <div
        class="header-menu-wrapper header-menu-wrapper-left"
        ref="kt_header_menu_wrapper"
      >
        <div class="d-flex gap-3 topbar-menu">
          <!-- <v-btn-toggle borderless dense> -->
          <v-btn
            @click="$router.push('/sales/salesorders')"
            v-if="permissionCan('sales.salesOrder.menu')"
            elevation="2"
            color="#232341"
            dark
          >
            <span class="hidden-sm-and-down">Sales orders</span>
            <v-icon class="flaticon2-list" right small></v-icon>
          </v-btn>

          <v-btn
            @click="$router.push('/sales/Orders')"
            v-if="permissionCan('sales.orders.menu')"
            elevation="2"
            color="#232341"
            dark
          >
            <span class="hidden-sm-and-down">Orders</span>
            <v-icon class="flaticon2-list" right small></v-icon>
          </v-btn>

          <v-btn
            @click="$router.push('/contacts/contactList')"
            v-if="permissionCan('contacts.contact.menu')"
            elevation="2"
            color="#232341"
            dark
          >
            <span class="hidden-sm-and-down">Contact list</span>
            <v-icon class="flaticon2-calendar-3" right small></v-icon>
          </v-btn>

          <v-btn
            @click="$router.push('/inventory/items')"
            v-if="permissionCan('inventory.item.menu')"
            elevation="2"
            color="#232341"
            dark
          >
            <span class="hidden-sm-and-down">Item catalogue</span>
            <v-icon class="flaticon-tabs" right small></v-icon>
          </v-btn>

            <v-btn
            @click="$router.push('/stock/stockItems')"
            v-if="permissionCan('module.stock.menu')"
            elevation="2"
            color="#232341"
            dark
          >
            <span class="hidden-sm-and-down">Stock List</span>
            <v-icon class="flaticon-event-calendar-symbol" right small></v-icon>
          </v-btn>
          <!-- </v-btn-toggle> -->
        </div>
        <div
          v-if="headerMenuEnabled"
          id="kt_header_menu"
          ref="kt_header_menu"
          class="header-menu header-menu-mobile"
          v-bind:class="headerMenuClasses"
        >
          <!-- example static menu here -->
          <KTMenu></KTMenu>
        </div>
      </div>
      <!-- end:: Header Menu -->
      <KTTopbar></KTTopbar>
    </div>
  </div>
  <!-- end:: Header -->
</template>

<script>
import { mapGetters } from "vuex";
import KTTopbar from "@/view/layout/header/Topbar.vue";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import KTLayoutHeaderMenu from "@/assets/js/layout/base/header-menu.js";
import KTMenu from "@/view/layout/header/Menu.vue";

export default {
  name: "KTHeader",
  components: {
    KTTopbar,
    KTMenu,
  },
  data() {
    return {
      permissions: []
    };
  },

  mounted() {
    // Init Desktop & Mobile Headers
    this.setPermissions();
    KTLayoutHeader.init("kt_header", "kt_header_mobile");

    // Init Header Menu
    KTLayoutHeaderMenu.init(
      this.$refs["kt_header_menu"],
      this.$refs["kt_header_menu_wrapper"]
    );
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),

    /**
     * Check if the header menu is enabled
     * @returns {boolean}
     */
    headerMenuEnabled() {
      return !!this.layoutConfig("header.menu.self.display");
    },

    /**
     * Get extra classes for header based on the options
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Get extra classes for header menu based on the options
     * @returns {null|*}
     */
    headerMenuClasses() {
      const classes = this.getClasses("header_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    }
  },
  methods: {
    permissionCan(action) {
      return this.permissions.find(x => x.name == action);
    },

    setPermissions() {
      if (localStorage.permissions) {
        this.permissions = JSON.parse(localStorage.permissions).filter(item => {
          return (
            item.name.indexOf("menu") > -1 || item.name.indexOf("modul") > -1
          );
        });
      }
    }
  }
};
</script>
